import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import { QuestionItem } from 'sections/Company/Faqs/SectionContent/Questions/QuestionItem';
import { IQuestion } from 'sections/Company/Faqs/types';
import styles from 'sections/Company/Faqs/SectionContent/Questions/Questions.module.scss';

const cn = classNames.bind(styles);

interface IQuestions {
  activeCategoryItems?: IQuestion[];
  activeQuestionId: number | null;
  setActiveQuestionId?: (id: number) => void;
  filteredItems?: IQuestion[];
  questionsStyles?: any;
}

const Questions = ({
  activeQuestionId,
  setActiveQuestionId,
  activeCategoryItems,
  filteredItems,
  questionsStyles,
}: IQuestions): ReactElement => {
  const onClickHandler = (id: number) => {
    setActiveQuestionId?.(id);
  };

  const defineArrayToMap = (categoryItems: any, filteredQuestions: any) => {
    if (categoryItems) {
      return categoryItems;
    } else {
      return filteredQuestions;
    }
  };

  const arrayToMap = defineArrayToMap(activeCategoryItems, filteredItems);

  const questionElements = arrayToMap?.map((item: IQuestion) => {
    return (
      <QuestionItem
        key={item.id}
        item={item}
        isActive={item.id === activeQuestionId || false}
        action={onClickHandler}
        activeQuestionId={activeQuestionId || 0}
      />
    );
  });

  return (
    <div className={cn('questions')} style={questionsStyles ? questionsStyles : {}}>
      {questionElements}
    </div>
  );
};

export { Questions };
